import { combineReducers } from "redux";
import adminReducer from "./admin/adminReducer";
import rolesReducer from "./roles/rolesReducer";

export const allReducers = combineReducers({
  admin: adminReducer,
  roles: rolesReducer,
});
